<script>
import moment from "moment";
import axios from '@/utils/axios';
import { allUsers } from '@/utils/user';
import "daterangepicker/daterangepicker.js";
import "daterangepicker/daterangepicker.css";
import DateRangePicker from "daterangepicker";
import { paymentGateway } from '@/utils/app-store';

export default {
  inject: ['setLoading'],
  data() {
    return {
      title: "Finance & Accounts",
      text: "Finance & Accounts",
      data: [],
      users: [],
      customers: [],
      pagination: {
       current_page: 1,
       per_page: 25,
       last_page: 1,
       total: 0,
       links: []
      },
      filter: {
       user: null,
       search: '',
       from_date: '',
       to_date: ''
      },
      app_currency: '',
      razorpay_status: ''
    };
  },

  computed: {
   text1(){
    return `Payment Links (${this.pagination.total})`;
   }, 
   serialNo(){
    return (this.pagination.current_page - 1) * this.pagination.per_page;
   } 
  },

  async mounted(){
   await this.loadAll(); 
  }, 

  methods: {

  async loadAll(){
   this.getUsers(); 
   this.paymentLinks();
   this.paymentGatewayStatus();
   this.app_currency = await this.$appCurrency();

   const start = moment().subtract(29, "days");
   const end = moment();

    new DateRangePicker(
      this.$refs.dateRangeInput,
      {
        startDate: start,
        endDate: end,
        locale: {
         format: "DD/MM/YYYY",
         separator: " - "
        },
        ranges: {
          Today: [moment(), moment()],
          Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
          "Last 7 Days": [moment().subtract(6, "days"), moment()],
          "Last 30 Days": [moment().subtract(29, "days"), moment()],
          "This Month": [moment().startOf("month"), moment().endOf("month")],
          "Last Month": [
            moment().subtract(1, "month").startOf("month"),
            moment().subtract(1, "month").endOf("month"),
          ],
        }
      },
      (start, end) => {
        this.setDateRange(start, end);
      },
      this.booking_range
     );
    // Initialize filter date range as soon as picker mounts
     this.setDateRange(start, end);   
    },  

    booking_range(start, end) {
     return start.format("DD/MM/YYYY") + " - " + end.format("DD/MM/YYYY");
    },

    setDateRange(start, end) {
     this.filter.from_date = start.format("YYYY-MM-DD");
     this.filter.to_date = end.format("YYYY-MM-DD");
    },

    async getUsers() {
     try{
      const response = await allUsers();
      this.users = response.data.data;
     }catch(error){
      this.$swalToast(error.message, 'error');
     }
    },

    async paymentLinks(page = 1) {
     this.setLoading(true);
     try{
      const params = {
       page,
       per_page:  this.pagination.per_page,
       user_id:   this.filter.user || '',
       from_date: this.filter.from_date,
       to_date:   this.filter.to_date,
       search:    this.filter.search.trim() || ''
      };
      const query_string = new URLSearchParams(params).toString();
      const response = await axios.get(`/payments/payment-links?${query_string}`);
      this.data = response.data.data.data;
      this.pagination = {
        current_page: response.data.data.current_page,
        per_page:     response.data.data.per_page,
        last_page:    response.data.data.last_page,
        total:        response.data.data.total,
        links:        response.data.data.links
      };
     }catch(error){
      this.$swalToast(error.message, 'error');
     }finally{
      this.setLoading(false);
     }
    },

    changePage(url){
     if (!url) return;
     const page = new URL(url).searchParams.get("page");
     this.paymentLinks(page);
    },

    async paymentGatewayStatus(){
     try{
      const data = await paymentGateway();
      this.razorpay_status = data.Razorpay;
     }catch(error){
      this.$swalToast(error.message, 'error');
     } 
    },

    clearFilter(){
     this.filter.user = null;
     this.filter.payment_date = '';
     this.filter.search = '';
     this.paymentLinks();
    },
    
  },
};
</script>

<template>
<layout-header></layout-header>
<layout-sidebar></layout-sidebar>

<!-- Page Wrapper -->
<div class="page-wrapper">
  <div class="content">
    <!-- Breadcrumb -->
    <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
      <breadcrumb :title="title" :text="text" :text1="text1" />
      <div class="d-flex my-xl-auto right-content align-items-center flex-wrap">
        
        <!-- <div class="me-2 mb-2" v-if="pagination.total">
        <div class="dropdown">
        <a href="javascript:void(0);" class="dropdown-toggle btn btn-white d-inline-flex align-items-center" data-bs-toggle="dropdown"><i class="ti ti-file-export me-1"></i>Export
        </a>
        <ul class="dropdown-menu dropdown-menu-end p-3">
        <li><a href="javascript:void(0);" class="dropdown-item rounded-1" @click="exportFile"><i class="ti ti-file-type-xls me-1"></i>Export as Excel</a>
        </li>
        </ul>
        </div>
        </div> -->
        
        <div class="mb-2" v-if="razorpay_status === 'Connected'">
          <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#payment_link_modal" class="btn btn-primary d-flex align-items-center" @click="$refs.paymentLinkModal.add();">
            <i class="ti ti-circle-plus me-2"></i>Add Payment Link
          </a>
        </div>
       
      </div>
    </div>
    <!-- /Breadcrumb -->

    <div class="card">
    <div class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
    <!-- <h5>paymentLinks List</h5> -->
    
    <div class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
    
    <div class="me-1" v-if="filter.search !== '' || filter.user !== null ">
     <a href="javascript:void(0);" class="text-danger" @click="clearFilter()"><i class="ti ti-filter-x"></i></a>
    </div>  

    <div class="me-3">
     <div class="input-icon-end position-relative">
      <input type="text" class="form-control date-range bookingrange" ref="dateRangeInput" placeholder="dd/mm/yyyy - dd/mm/yyyy">
      <span class="input-icon-addon"><i class="ti ti-chevron-down"></i></span>
     </div>
    </div>
    
    <div class="me-3 custom-vueselect">
     <vue-select v-model="filter.user" :options="users" label="name" :reduce="user => user.id" placeholder="Users" @change="paymentLinks" />
    </div>

    <div class="me-3">
    <div class="input-icon-end position-relative">
     <input type="text" class="form-control" v-model="filter.search" placeholder="Search...."/>
    </div>
    </div>

    <div class="">
     <button type="button" class="btn btn-dark" @click="paymentLinks()"><i class="ti ti-search"></i></button>
    </div>

    </div>
    
   </div>

  <div class="card-body card-table-wrapper">
    <div class="custom-datatable-filter table-responsive" v-if="data?.length">
      <table class="card-table">
        <thead>
          <tr>
            <th>#</th>
            <th>Amount</th>
            <th>Status</th>
            <th>Client</th>
            <th>Created By</th>
            <th>Date</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in data" :key="row.id">
            <td>{{ serialNo + index + 1 }}.</td>  
            <td><a href="javascript:void(0);" class="fw-bold" data-bs-toggle="modal" data-bs-target="#payment_link_view_modal" @click="$refs.paymentLinkModal.detail(row);">{{ app_currency?.code }} {{ row.amount }}</a> 
             <br>
             <a :href="row.short_url" target="_blank" class="me-1 text-primary">{{ row.short_url }}</a>
             <a href="javascript:void(0);" @click="$copyText(row.short_url)" class="text-primary"><i class="ti ti-copy"></i></a>    
            </td>
            <td><span :class="{'badge' : true,
                               'text-capitalize' : true,
                               'bg-success' : row.status === 'paid',
                               'bg-danger'  : row.status === 'unpaid'
                              }">{{ row.status }}</span></td>
            <td><a :href="$partyURL(row.party_id, row.party_type)" target="_blank" class="text-primary">{{ row?.name }}</a></td>
            <td><img :src="$profileImage(row.user.image, clientAdmin)" width="22" /> {{ row.user.name }}</td>
            <td>{{ $formatDate(row.created_at, 'DD-MM-YYYY') }}</td>
            <td>
            <div class="dropdown">
            <button class="btn btn-icon btn-sm rounded-circle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
            <i class="ti ti-dots-vertical"></i>
            </button>
            <ul class="dropdown-menu dropdown-menu-end p-3">
            <li>
            <a class="dropdown-item rounded-1" href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#payment_link_delete_modal" @click="$refs.paymentLinkModal.detail(row)"><i class="ti ti-trash me-1"></i>Delete</a>
            </li>
            </ul>
            </div>  
            </td>

          </tr>
        </tbody>
      </table>

      <!-- Pagination -->
    <nav v-if="pagination.links.length > 3" class="mt-2 margin-l-2">
     <ul class="pagination pagination-sm">
      <li v-for="(link, index) in pagination.links" :key="index" :class="['page-item', { active: link.active, disabled: !link.url }]">
        <a class="page-link" href="javascript:void(0)" v-html="link.label" @click="changePage(link.url)"></a>
      </li>
     </ul>
    </nav>

    </div>

    <div v-else class="p-3 text-center text-muted"> No records found.</div>
    
  </div>
</div>
</div>

<app-footer></app-footer>

</div>
<!-- /Page Wrapper -->

<payment-link-modal ref="paymentLinkModal" @updated="loadAll"></payment-link-modal>
</template>